import { htmlLang } from '../constants/index.js'
import { PARTICIPATING_COUNTRIES } from '../../../shared/constants.js'
import { useSafeLocalStorage } from './useSafeLocalStorage.js'

const geoCode = htmlLang[1]
const isParticipating = (PARTICIPATING_COUNTRIES as readonly string[]).includes(
  geoCode,
)

// htmlCode is interpolated into BCP 47 locale tags — must be a real ISO country.
export const htmlCode = isParticipating ? geoCode : 'AT'

export const defaultRegion = isParticipating ? geoCode : 'ROW'

const isValidRegion = (code: string) =>
  code === 'ROW' ||
  (PARTICIPATING_COUNTRIES as readonly string[]).includes(code)

export const useSelectedVotingRegion = (): [string, (code: string) => void] =>
  useSafeLocalStorage<string>(
    '2026votingRegion-selected',
    defaultRegion,
    isValidRegion,
  )
